define( 'controllers/paypalCheckout',[], function () {
	/**
	 * PayPal's buttons, on the form, once the server has halted the submission.
	 *
	 * The submission halts server-side with everything the order will need
	 * already decided — the amount, the fee, the merchant — and the browser
	 * never trusted with any of it. This puts PayPal's own buttons in front of
	 * the visitor; the order itself is created on the click, because PayPal
	 * require it to name the method it will be paid with and that is the first
	 * moment anyone knows which. On approval the form resumes and the server
	 * captures. It is the sequence the paid PayPal Checkout add-on ships, and
	 * the halt/resume seam underneath is core's existing one.
	 *
	 * Nothing here decides how PayPal's SDK is set up. The service does that
	 * and sends it with the order, so the day PayPal confirms the third-party
	 * parameter set no site needs a plugin update. That is why this file passes
	 * `sdk.instance` through verbatim and reads element and session names from
	 * `sdk.methods` rather than knowing any of them.
	 *
	 * PayPal's Web SDK v6, which they require for certification. v6 puts no
	 * configuration in the script URL and gives each payment method its own
	 * element and its own payment session, where v5 had one `paypal.Buttons()`
	 * that drew the whole stack.
	 */
	var controller = Marionette.Object.extend( {
		/**
		 * Listen for the form submission events this controller handles: a
		 * response that may carry a PayPal halt or a declined resume, and a
		 * submit press that should clear our last error.
		 *
		 * @return {void}
		 */
		initialize: function () {
			this.listenTo(
				nfRadio.channel( 'forms' ),
				'submit:response',
				this.paypalCheckout
			);
			this.listenTo(
				nfRadio.channel( 'forms' ),
				'submit:response',
				this.keepAnswers
			);
			this.listenTo(
				nfRadio.channel( 'forms' ),
				'before:submit',
				this.letThemTryAgain
			);
			this.listenTo(
				nfRadio.channel( 'forms' ),
				'submit:response',
				this.quietConfirmation
			);
		},

		/**
		 * Draw no focus box around the confirmation a paid submission shows.
		 *
		 * Core focuses a form's success message so a screen reader reads it,
		 * and after a PayPal payment that focus lands on a page the visitor
		 * has just returned to, outlining the whole message. The outline goes
		 * for this flow only, and only until the visitor presses Tab: from
		 * then on focus is the keyboard's and shows as usual.
		 *
		 * @param {Object} response The submission response.
		 * @return {void}
		 */
		quietConfirmation: function ( response ) {
			if ( ! this.paid( response ) ) return;

			var container = jQuery(
				'#nf-form-' + response.data.form_id + '-cont'
			).addClass( 'nf-paypal-quiet-focus' );

			jQuery( document ).on(
				'keydown.nfPaypalQuietFocus',
				function ( event ) {
					if ( 'Tab' !== event.key ) return;
					container.removeClass( 'nf-paypal-quiet-focus' );
					jQuery( document ).off( 'keydown.nfPaypalQuietFocus' );
				}
			);
		},

		/**
		 * A resumed PayPal submission that went through.
		 *
		 * @param {Object} response The submission response.
		 * @return {boolean} Whether this is a completed PayPal submission.
		 */
		paid: function ( response ) {
			if ( 'undefined' == typeof response.data ) return false;
			if ( ! response.data.resume ) return false;
			if ( 'undefined' == typeof response.data.extra ) return false;
			if ( 'undefined' == typeof response.data.extra.nf_paypal_order )
				return false;

			return 0 === _.size( response.errors );
		},

		/**
		 * Take the last payment's message off the form when the visitor tries
		 * again.
		 *
		 * A form-level error blocks submission for as long as it is on the
		 * model — core checks for one and refuses before it sends anything. So
		 * a visitor told "PayPal could not complete your payment, please try
		 * again" pressed the button and nothing at all happened: the sentence
		 * asking them to retry was itself what stopped the retry. Their only
		 * way out was reloading the page, which is exactly the starting over
		 * PayPal ask us not to make them do.
		 *
		 * Cleared when they press the button rather than when the message is
		 * shown, so the explanation stays on screen until they act on it. Only
		 * ours, by id: another action's error is that action's to withdraw.
		 *
		 * @param {Backbone.Model} formModel The form being submitted.
		 * @return {void}
		 */
		letThemTryAgain: function ( formModel ) {
			nfRadio
				.channel( 'form-' + formModel.get( 'id' ) )
				.request( 'remove:error', 'paypal' );
		},

		/**
		 * A payment that did not go through must not cost the visitor their
		 * answers.
		 *
		 * Approving sends the browser back to the page carrying nf_resume, so
		 * the form on screen is a freshly rendered, empty one and core re-runs
		 * the submission from its own session behind it. When that pass ends in
		 * an error — PayPal refused the card, the capture failed — the fields
		 * are un-hidden again and every one of them is blank. The visitor is
		 * told to try again and handed an empty form to retype, which is the
		 * one thing PayPal's own guidance says not to do: let the buyer try
		 * another way to pay without starting over.
		 *
		 * The answers are already in the response. Core sends the resumed
		 * submission's fields back with their values, from the session it
		 * halted with, so nothing new has to be stored or transmitted — it only
		 * has to be put back on screen.
		 *
		 * Only the resumed pass, and only when it failed. A successful payment
		 * ends the submission, and whether the form is then cleared is the
		 * merchant's setting to make.
		 *
		 * @param {Object} response The submission response.
		 * @return {void}
		 */
		keepAnswers: function ( response ) {
			if ( ! this.declined( response ) ) return;

			var controller = this;

			jQuery.each( response.data.fields, function ( fieldID, field ) {
				if ( ! field || controller.unrestorable( field.type ) ) return;
				if ( 'undefined' == typeof field.value || '' === field.value )
					return;

				var model = nfRadio
					.channel( 'fields' )
					.request( 'get:field', fieldID );
				if ( ! model ) return;

				model.set( 'value', field.value );

				// The template reads the value; nothing re-reads it on its
				// own. This is core's existing way of putting a model change
				// on screen — conditional logic and calculations use it too.
				model.trigger( 'reRender' );
			} );
		},

		/**
		 * A resumed PayPal submission that came back with something wrong.
		 *
		 * Strict on all three counts. Another gateway's resume, a first-pass
		 * validation failure, or a response some other plugin shaped
		 * differently must all leave the form exactly as it is.
		 *
		 * @param {Object} response The submission response.
		 * @return {boolean} Whether this is a failed resumed PayPal submission.
		 */
		declined: function ( response ) {
			if ( 'undefined' == typeof response.data ) return false;
			if (
				'undefined' == typeof response.data.resume ||
				! response.data.resume
			)
				return false;
			if ( 'undefined' == typeof response.data.fields ) return false;
			if ( 'undefined' == typeof response.data.extra ) return false;
			if ( 'undefined' == typeof response.data.extra.nf_paypal_order )
				return false;

			return 0 < _.size( response.errors );
		},

		/**
		 * Fields whose value is not the visitor's to be given back.
		 *
		 * A captcha token is spent, so re-rendering one would prove the
		 * visitor is a robot. A password does not belong in a value attribute
		 * on a page anyone can walk past. Card fields are PayPal's now, and
		 * never ours to hold. A repeater's value is a nested structure with
		 * its own views, and putting it back is a job of its own rather than
		 * something to half-do here. The rest have no value to lose.
		 *
		 * @param {string} type The field type.
		 * @return {boolean} Whether the field must not have its value restored.
		 */
		unrestorable: function ( type ) {
			return (
				-1 <
				jQuery.inArray( type, [
					'submit',
					'button',
					'html',
					'hr',
					'note',
					'spam',
					'recaptcha',
					'recaptcha_v3',
					'hcaptcha',
					'turnstile',
					'password',
					'passwordconfirm',
					'creditcard',
					'creditcardcvc',
					'creditcardexpiration',
					'creditcardfullname',
					'creditcardnumber',
					'creditcardzip',
					'signature',
					'repeater',
					'total',
				] )
			);
		},

		/**
		 * Put the PayPal approval step on a form the server has halted for payment.
		 *
		 * Announces why the form stopped, draws PayPal's buttons (or the test
		 * button when the service sent no SDK), and moves focus to the region.
		 * Any response that is not a PayPal halt is ignored.
		 *
		 * @param {Object} response The submission response.
		 * @return {void}
		 */
		paypalCheckout: function ( response ) {
			var order = this.order( response );
			if ( ! order ) return;

			var formID = response.data.form_id;
			var container = this.container( formID );
			if ( ! container.length ) return;

			// Said before the control is drawn, so a screen reader hears why
			// the form has stopped rather than only what appeared. Nothing
			// else on the page explains the pause, and in production the
			// control itself is inside PayPal's iframe, which a live region
			// cannot announce.
			jQuery( '<p class="nf-paypal-status" role="status"></p>' )
				.text( nfi18n.paypalApprovalNeeded )
				.appendTo( container );

			// No script means the service has no PayPal credentials and is
			// running its fake. A fake cannot serve real buttons, so rather
			// than loading a script that would fail, offer the deterministic
			// button the walkthrough drives. This is also the only path that
			// runs in CI.
			if ( order.sdk && order.sdk.url ) {
				this.renderButtons( order, formID, container );
			} else {
				this.renderTestButton( formID, container );
			}

			// Focus the region, not the control. Submitting drops focus to the
			// document body — Backbone replaces the submit button's node as it
			// re-renders — so a keyboard visitor would otherwise have to tab
			// from the top of the page to find what to do next. The region is
			// focusable rather than the button because in production the
			// button belongs to PayPal's iframe and cannot be focused from
			// here.
			container.get( 0 ).focus();
		},

		/**
		 * The order this halt is about, or nothing.
		 *
		 * Deliberately strict: another gateway's halt, a halt with no payment,
		 * or a response shaped differently by some other plugin must all leave
		 * this controller silent rather than guessing.
		 *
		 * @param {Object} response The submission response.
		 * @return {Object|false} The halted PayPal order, or false when this
		 *                        response is not one.
		 */
		order: function ( response ) {
			if ( 'undefined' == typeof response.data ) return false;
			if (
				'undefined' == typeof response.data.halt ||
				! response.data.halt
			)
				return false;
			if ( 'undefined' == typeof response.data.extra ) return false;

			var order = response.data.extra.nf_paypal_order;

			// No order id yet, by design: it is created when a button is
			// pressed. What marks this as ours is the halt state the gateway
			// wrote.
			if ( 'undefined' == typeof order || ! order || ! order.status )
				return false;

			return order;
		},

		/**
		 * A place to put the buttons, made once and reused on a retry.
		 *
		 * @param {string} formID The form being paid for.
		 * @return {jQuery} The approval region, or an empty set when the form
		 *                  is not on the page.
		 */
		container: function ( formID ) {
			var form = jQuery( '#nf-form-' + formID + '-cont' );
			if ( ! form.length ) return form;

			var existing = form.find( '.nf-paypal-checkout' );
			if ( existing.length ) return existing.empty().show();

			// Grouped and labelled so the step is announced as one thing, and
			// focusable programmatically without entering the tab order twice.
			return jQuery( '<div class="nf-paypal-checkout"></div>' )
				.attr( {
					role: 'group',
					tabindex: '-1',
					'aria-label': nfi18n.paypalApprovalRegion,
				} )
				.appendTo( form );
		},

		/**
		 * Load PayPal's SDK and draw the order's payment method buttons, with an
		 * error region that reports a failure to load or draw them.
		 *
		 * @param {Object} order     The halted PayPal order, carrying `sdk`.
		 * @param {string} formID    The form being paid for.
		 * @param {jQuery} container The approval region to draw into.
		 * @return {void}
		 */
		renderButtons: function ( order, formID, container ) {
			var controller = this;
			var buttons = jQuery(
				'<div class="nf-paypal-buttons"></div>'
			).appendTo( container );
			var errors = jQuery(
				'<div class="nf-paypal-error" role="alert"></div>'
			).appendTo( container );

			var failed = function () {
				errors.text( nfi18n.paypalError ).show();
			};

			this.loadSdk(
				order.sdk,
				function () {
					controller
						.renderMethods(
							order,
							formID,
							buttons.get( 0 ),
							errors
						)
						.then( null, failed );
				},
				failed
			);
		},

		/**
		 * Draw a button for every method the merchant wants and PayPal allows.
		 *
		 * Two gates, and they answer different questions. The service already
		 * dropped what this merchant was never vetted for; `findEligibleMethods`
		 * answers for this buyer — Venmo outside the US being the case that
		 * catches people. Drawing a button PayPal will not honour looks like a
		 * broken payment rather than an unavailable one.
		 *
		 * @param {Object}      order  The halted PayPal order, carrying `sdk`.
		 * @param {string}      formID The form being paid for.
		 * @param {HTMLElement} mount  Where the buttons are appended.
		 * @param {jQuery}      errors The error region.
		 * @return {Promise} Settles once the eligible buttons are drawn.
		 */
		renderMethods: function ( order, formID, mount, errors ) {
			var controller = this;
			var sdk = order.sdk;

			return window.paypal
				.createInstance( sdk.instance )
				.then( function ( instance ) {
					return instance
						.findEligibleMethods( {
							currencyCode: sdk.currencyCode,
						} )
						.then( function ( eligible ) {
							var drawn = 0;

							jQuery.each(
								sdk.methods,
								function ( index, method ) {
									if ( ! eligible.isEligible( method.name ) )
										return;

									// One method's failure must not take the rest down.
									// The SDK throws from an element's connectedCallback
									// when it dislikes where the element sits, and an
									// uncaught throw here left the visitor with whatever
									// had been drawn so far and no explanation.
									try {
										controller.renderMethod(
											instance,
											order,
											formID,
											mount,
											errors,
											method,
											eligible.getDetails(
												method.name
											) || {}
										);
										drawn++;
									} catch ( error ) {
										if (
											window.console &&
											window.console.error
										) {
											window.console.error(
												'Ninja Forms PayPal: could not draw ' +
													method.name,
												error
											);
										}
									}
								}
							);

							// The visitor is holding a halted form with no way to pay
							// it. Saying nothing would leave them waiting for buttons
							// that are never coming.
							if ( ! drawn )
								errors.text( nfi18n.paypalNoMethods ).show();
						} );
				} );
		},

		/**
		 * One method: its button, and the payment session behind it.
		 *
		 * The element and the session factory are both named by the service.
		 * Reading them rather than hard-coding them is what lets PayPal add or
		 * rename a method without a plugin release.
		 *
		 * @param {Object}      instance The PayPal SDK instance.
		 * @param {Object}      order    The halted PayPal order, carrying `sdk`.
		 * @param {string}      formID   The form being paid for.
		 * @param {HTMLElement} mount    Where the button is appended.
		 * @param {jQuery}      errors   The error region.
		 * @param {Object}      method   The service's description of the method.
		 * @param {Object}      details  PayPal's eligibility details for it.
		 * @return {void}
		 */
		renderMethod: function (
			instance,
			order,
			formID,
			mount,
			errors,
			method,
			details
		) {
			var controller = this;

			var session = instance[ method.session ]( {
				onApprove: function () {
					controller.resume( formID );
				},

				// A cancelled payment is not a failure: the submission is
				// still halted and unpaid, and the visitor can approve
				// again without refilling the form.
				onCancel: function () {
					errors.text( nfi18n.paypalCancelled ).show();
				},

				onError: function () {
					errors.text( nfi18n.paypalError ).show();
				},
			} );

			var button = document.createElement( method.element );

			jQuery.each( method.attributes || {}, function ( name, value ) {
				button.setAttribute( name, value );
			} );

			// Some buttons will not draw until told what PayPal decided for
			// this merchant and buyer — Pay Later needs the country and
			// product it advertises, and only the eligibility answer knows.
			// The service names which attribute takes which detail; this
			// copies and asks no questions.
			jQuery.each(
				method.attributesFromEligibility || {},
				function ( attribute, detail ) {
					if (
						'undefined' != typeof details[ detail ] &&
						null !== details[ detail ]
					) {
						button.setAttribute( attribute, details[ detail ] );
					}
				}
			);

			button.addEventListener( 'click', function () {
				// Clear the last attempt's message. Leaving "cancelled" on
				// screen while a new approval is open reads as a failure that
				// has not happened.
				errors.hide();

				// The order is made by our server now, for this method, and
				// v6 takes a promise for it. The server already knows the
				// amount and the fee; the only thing this tells it is which
				// button was pressed.
				//
				// `{ orderId: ... }`, not the bare id: the id alone is
				// rejected with "order ID must be a string"
				// (ERR_INIT_ORDER_ID_MUST_BE_STRING), which reads as though a
				// string is wanted and means the opposite — PayPal want the
				// object whose `orderId` property is one.
				// Most buttons open the way the page asked; a button the SDK
				// only lets open one way (the guest card form, modal only)
				// says so and wins. Anything else a session's start() needs
				// (Venmo's sandbox flag, today) the service names and this
				// passes through, so it is never a plugin release.
				session
					.start(
						jQuery.extend( {}, method.startOptions || {}, {
							presentationMode:
								method.presentationMode ||
								order.sdk.presentationMode,
						} ),
						controller
							.createOrder( formID, method.name )
							.then( function ( created ) {
								return { orderId: created.orderId };
							} )
					)
					.then( null, function ( error ) {
						// Every failure here otherwise collapses into one sentence
						// with nothing to debug from — which is what hid the shape
						// error above through a whole round of testing. The
						// visitor still sees only the plain message.
						if ( window.console && window.console.error ) {
							window.console.error(
								'Ninja Forms PayPal:',
								error
							);
						}

						errors.text( nfi18n.paypalError ).show();
					} );
			} );

			// Some buttons only work inside a wrapper element the SDK
			// defines - the guest card button refuses to connect anywhere
			// else. The service names it; this file does not know which.
			if ( method.container ) {
				var wrapper = document.createElement( method.container );
				wrapper.appendChild( button );
				mount.appendChild( wrapper );
			} else {
				mount.appendChild( button );
			}
		},

		/**
		 * The stand-in for a service running the fake PayPal.
		 *
		 * It resumes the submission exactly as an approval does, which is what
		 * makes the walkthrough a test of our plumbing — the halt, the order,
		 * the resume, the capture, the entry — rather than a test of PayPal's
		 * buttons, which no fake can provide.
		 *
		 * @param {string} formID    The form being paid for.
		 * @param {jQuery} container The approval region to draw into.
		 * @return {void}
		 */
		renderTestButton: function ( formID, container ) {
			var controller = this;

			// Even the stand-in creates the order first: that is the money
			// path the walkthrough exists to prove, and skipping it here
			// would leave the click that matters untested in CI.
			jQuery(
				'<button type="button" class="nf-paypal-test-approve"></button>'
			)
				.text( nfi18n.paypalTestApprove )
				.on( 'click', function () {
					controller.createOrder( formID, 'paypal' ).then(
						function () {
							controller.resume( formID );
						},
						function () {
							container.find( '.nf-paypal-error' ).remove();
							jQuery(
								'<div class="nf-paypal-error" role="alert"></div>'
							)
								.text( nfi18n.paypalError )
								.appendTo( container );
						}
					);
				} )
				.appendTo( container );
		},

		/**
		 * Ask our server to create the order for the button just pressed.
		 *
		 * Everything the order needs was fixed when the form was submitted and
		 * lives with the halted submission on the server; this sends the one
		 * thing only the browser knows, which button. Resolves with the order
		 * id PayPal issued. The same nonce the form itself submitted with, so a
		 * page open past midnight fails here the same way it fails there.
		 *
		 * @param {string} formID The form being paid for.
		 * @param {string} method The payment method pressed, e.g. "paypal".
		 * @return {Promise<Object>} The response data, including `orderId`.
		 */
		createOrder: function ( formID, method ) {
			return new Promise( function ( resolve, reject ) {
				jQuery
					.ajax( {
						url: nfFrontEnd.adminAjax,
						type: 'POST',
						dataType: 'json',
						data: {
							action: 'nf_paypal_order',
							form_id: formID,
							method: method,
							security: nfFrontEnd.ajaxNonce,
							nonce_ts: nfFrontEnd.nonce_ts,
						},
					} )
					.done( function ( response ) {
						if (
							response &&
							response.success &&
							response.data &&
							response.data.orderId
						) {
							resolve( response.data );
						} else {
							if ( window.console && window.console.error ) {
								window.console.error(
									'Ninja Forms PayPal: order not created',
									response
								);
							}
							reject( response );
						}
					} )
					.fail( function ( xhr ) {
						if ( window.console && window.console.error ) {
							window.console.error(
								'Ninja Forms PayPal: order request failed',
								xhr
							);
						}
						reject( xhr );
					} );
			} );
		},

		/**
		 * Hand the form back to the server to finish.
		 *
		 * Core watches for nf_resume and re-submits; preserve_extra_data names
		 * the key whose extra data must survive the round trip, which is how
		 * the order id reaches the capture.
		 *
		 * @param {string} formID The form to resume.
		 * @return {void}
		 */
		resume: function ( formID ) {
			window.location.search +=
				'&nf_resume=' + formID + '&preserve_extra_data=nf_paypal_order';
		},

		/**
		 * Load PayPal's core script once, however many forms are on the page.
		 *
		 * v6 takes no configuration in the URL — the script is the same for
		 * every merchant, and everything that differs between them is handed to
		 * createInstance afterwards.
		 *
		 * @param {Object}   sdk     The order's SDK settings, carrying `url`.
		 * @param {Function} onReady Called once the SDK is available.
		 * @param {Function} onError Called if the script fails to load.
		 * @return {void}
		 */
		loadSdk: function ( sdk, onReady, onError ) {
			if ( 'undefined' != typeof window.paypal ) return onReady();

			var existing = document.getElementById( 'nf-paypal-sdk' );
			if ( existing ) {
				existing.addEventListener( 'load', onReady );
				existing.addEventListener( 'error', onError );
				return;
			}

			var script = document.createElement( 'script' );

			script.id = 'nf-paypal-sdk';
			script.src = sdk.url;
			script.async = true;
			script.onload = onReady;
			script.onerror = onError;

			document.body.appendChild( script );
		},
	} );

	return controller;
} );

